// Add to cart
function addToCartClick(variantID, openCartDrawer = false) {
  // let itemsArray = { quantity: 1, id: variantID };
  // console.log("AddToCartClick: ", itemsArray);
  btnLoading(variantID, true);

  const cartDrawer = document.querySelector("cart-drawer");
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(itemsArray),
    // TODO: @alex - test how to make it work without items
    body: JSON.stringify({
      items: [{ quantity: 1, id: variantID }],
      // functioning
      // sections: cartDrawer.getSectionsToRender().map((section) => section.id),
    }),
  })
    .then((resp) => {
      if (!resp.ok) {
        throw new Error("Network response was not ok");
      }
      return resp.json();
    })
    .then((success) => {
      // console.log("S--> ", success);
      const functioning = false;
      if (functioning) {
        cartDrawer.renderContents(success);
      }

      // Fetch updated cart data and publish cart update event
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          // Publish cart update event for components like the free shipping progress bar
          if (
            typeof publish === "function" &&
            typeof PUB_SUB_EVENTS !== "undefined"
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "add-to-cart",
              cartData: cartData,
              variantId: variantID,
            });
          }

          // Also dispatch custom event for broader compatibility
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: cartData,
            }),
          );
        })
        .catch((error) => {
          console.error("Error fetching updated cart data:", error);
        });

      // Refresh the cart drawer section content via Section Rendering API
      refreshCartDrawerSection();
      let cartDrawerEmpty =
        document.getElementById("cart-drawer-empty") || null;
      if (cartDrawerEmpty) {
        cartDrawerEmpty.classList.add("tw-hidden");
      }
      btnLoading(variantID, false);
      console.log("MrBeast | Add to cart - Success");
      // Open the cart drawer
      if (openCartDrawer) {
        setTimeout(() => {
          document.getElementById("cart-icon-bubble").click();
        }, 500);
      }
    })
    .catch((error) => {
      btnLoading(variantID, false);
      console.log("Error, please report it to: turati@mrbeastyoutube.com");
      console.log(JSON.stringify(error));
    });
}

// Refresh the cart drawer section using Shopify's Section Rendering API
function refreshCartDrawerSection() {
  fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const cartDrawer = document.querySelector("cart-drawer");

      // Update the cart drawer with fresh content
      const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }

      // Also update the cart icon bubble count
      fetch(`${window.Shopify.routes.root}cart?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((iconHtml) => {
          const iconDoc = new DOMParser().parseFromString(
            iconHtml,
            "text/html",
          );
          const iconTarget = document.getElementById("cart-icon-bubble");
          const iconSource = iconDoc.querySelector(".shopify-section");
          if (iconTarget && iconSource) {
            iconTarget.innerHTML = iconSource.innerHTML;
          }
        })
        .catch((e) => console.error("Error updating cart icon:", e));

      // Update is-empty class on cart-drawer
      if (cartDrawer) {
        const newCartDrawer = html.querySelector("cart-drawer");
        if (newCartDrawer) {
          cartDrawer.classList.toggle(
            "is-empty",
            newCartDrawer.classList.contains("is-empty"),
          );
        }
      }
    })
    .catch((error) => {
      console.error("Error refreshing cart drawer section:", error);
    });
}
function btnLoading(variantID, state) {
  let btn = document.getElementById(`btn-${variantID}`);
  if (state) {
    btn.classList.add("loading");
    btn.disabled = true;
  } else {
    btn.classList.remove("loading");
    btn.disabled = false;
  }
}
